import { NSValidation } from './../../classes/NSValidation';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
declare var bootbox:any;
@Component({
  selector: 'app-organization-department-ne',
  template: require('./organization-department-ne.component.html')
})
export class OrganizationDepartmentNeComponent extends BaseComponent implements OnInit {

  public department = {
    name:""
  };

  public departmentId = -1;


  public organizationId = -1;

  
  ngOnInit() {
    super.ngOnInit();
  }

  public routeParamsUpdated() {
    this.organizationId = this.default(this.currentRouteParams["orgId"],-1);
    this.departmentId = this.default(this.currentRouteParams["deptId"],-1);
    if(this.departmentId>0)
      this.loadDepartmentById();
    else 
      this.departmentId = -1;
  }

  public loadDepartmentById() {
      this.busy = this.lsApi.getDepartmentById(this.departmentId).subscribe(resp => {
        if(resp.status) {
            this.department = resp.data[0];
        }
    },
    error => {
        console.log(error);
    });
  }

  public save() {
    var validate:NSValidation = new NSValidation();

    var errorMessage = "";
    if(validate.isEmpty(this.department.name)) {
        errorMessage = "Please provide a name for this department";
    }

    if(errorMessage!="") {
        bootbox.alert(errorMessage);
    }
    else {
        this.busy = this.lsApi.saveDepartment(this.departmentId, this.department.name, this.organizationId).subscribe(resp => {
            if(resp.status) {
                this.router.navigate(['/admin/organizations',this.organizationId,'departments']).then(() => {
                  this.appToast.success("Department Successfully Saved","Department Saved")
                })
            }
        },
        error => {
            console.log(error);
        });
    }
  }

  public cancel() {
    this.router.navigate(['/admin/organizations',this.organizationId,'departments']);
  }

  public delete() {

    bootbox.confirm({message:"Do you want to delete '" + this.department.name + "' department and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteDepartmentById(this.departmentId).subscribe(resp => {
              if(resp.status) {
                  this.router.navigate(['/admin/organizations',this.organizationId,'departments']).then(() => {
                    this.appToast.success("Department Successfully Deleted","Department Deleted")
                  })
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/organization-department-ne/organization-department-ne.component.ts